export class GetAttendanceTrackingRequest {
    ClassID?: number;
    TrainerID?: number;
    StartDate: Date;
    EndDate: Date; // Make sure your end date is time aware - if you want all requests on 10/28/2018, pass  10/28/2018 11:59:59 PM.  Or 10/29/2018 would also work, assuming events always have both a date and time.
}
